export default {
  APIROOT: 'https://crm-immo-api.osc-fr1.scalingo.io',
  APIURL: 'https://crm-immo-api.osc-fr1.scalingo.io/api/v1.0',
  GRAPHQL_API: 'https://crm-immo-graphql.osc-fr1.scalingo.io/graphql',
  // APIROOT: 'https://dicg-crm.osc-fr1.scalingo.io',
  // APIURL: 'https://dicg-crm.osc-fr1.scalingo.io/api/v1.0',
  // GRAPHQL_API: 'https://dicg-graphql.osc-fr1.scalingo.io/graphql',
  APPHOST: 'https://crm-immo.okgo.space',
  MOBILE_HOST: null,
  ALGOLIA_APP_ID: 'HQK9I3XA8A',
  ALGOLIA_SEARCH_KEY: '40512f584850e6cae4a180db6fba8af0',
  GOOGLE_API_KEY: 'AIzaSyA-PmxuiRSHJtfsJSSvM23X7Oiaal_yDWI',
  GOOGLE_CLIENT_ID: '610084616522-u551i4ictgmivd3r0vpago3jb4dn6r9r.apps.googleusercontent.com',
  ENABLE_GOOGLE_APIS: false,
  CONTENTFUL_SPACE_ID: '1gymb3e2piir',
  CONTENTFUL_ACCESS_TOKEN: 'afd209d71174301d3271784f835a4b2583bf61cf6a3b9b2eba12ff61f0ef3c5d',
  COMPANY: 'CRM Immo',
  COMPANY_COLOR: '#FFFFFF',
  LOGO_LOGIN: 'https://s3.eu-west-3.amazonaws.com/crm-immo/src/logo-login.png',
  LOGO_MAIN: 'https://s3.eu-west-3.amazonaws.com/crm-immo/src/logo-menu.png',
  MOBILE_WEBSITE: 'm-crm.okgo.space',
  MANIFEST: '/static/favicons/manifest.json',
  FAVICON_32: '/static/favicons/favicon-32x32.png',
  FAVICON_16: '/static/favicons/favicon-16x16.png',
  FAVICON_CHROME_192: '/static/favicons/android-chrome-192x192.png',
  FAVICON_CHROME_256: '/static/favicons/android-chrome-256x256.png',
  FAVICON_APPLE: '/static/favicons/favicon-apple-touch-icon.png',
  SENTRY_DSN: 'https://d5563f018f784ee3a7171bb48f4323df@sentry.io/1299182'
}



//////////////////
// WEBPACK FOOTER
// ./config/runtimeConf/default.js
// module id = null
// module chunks = 